import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { Assignment } from './assignment';
export var PracticeAssignment = /*#__PURE__*/function (_Assignment) {
  _inherits(PracticeAssignment, _Assignment);

  var _super = _createSuper(PracticeAssignment);

  function PracticeAssignment() {
    _classCallCheck(this, PracticeAssignment);

    return _super.apply(this, arguments);
  }

  _createClass(PracticeAssignment, [{
    key: "complete",
    value: function complete(endTime) {
      this.props.endTime = endTime;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var validatedBasePropsOrError = _get(_getPrototypeOf(PracticeAssignment), "validateBaseProps", this).call(this, props);

      if (validatedBasePropsOrError.isFailure) {
        return Result.fail(validatedBasePropsOrError.error);
      }

      var guardCollection = [{
        argument: props.isShowingScore,
        argumentName: 'Is Showing Score'
      }, {
        argument: props.duration,
        argumentName: 'Duration'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new PracticeAssignment(props, new UniqueEntityID(props.id)));
    }
  }]);

  return PracticeAssignment;
}(Assignment);